// This file is maintained for backward compatibility.
// It re-exports all functionality from the modularized services.
export * from "./employees";

// Re-export invitation service functions for backward compatibility
import invitationService from "./employees/invitationService";
export const fetchInvitations = invitationService.fetchInvitations;
export const revokeInvitation = invitationService.revokeInvitation;

// Re-export the employee management functions
export {
  addEmployee,
  updateEmployeeRole,
  removeEmployee,
} from "./employees/employeeManagement";

export { fetchEmployees } from "./employees/fetchEmployees";

// Re-export invitation services
export { acceptInvitation } from "./employees/invitation/acceptInvitation";
export { createEmployeeInvitation } from "./employees/invitation/createInvitation";

// Re-export other employee services as needed
export * from "./employees/employeeLoggingService";

// Keep backward compatibility with old imports
import { getEmployeesData } from "./employees/compatibilityLayer";
export { getEmployeesData };
